export const authSelectors = {
  getIsAuthenticated: state => state.auth.isAuthenticated,
  getUser: state => state.auth.user,
  getUserOrganizations: state => state.auth.userOrganizations,
  isFetching: state => state.auth.isFetching,
};
